import axios from "axios";
import { host, port, path, version } from "../systemVariables";

const resource = "/languages";

export const LIST_LANGUAGES = "LIST_LANGUAGES";

export function listLanguages(callback) {
  return (dispatch) => {
    axios
      .get(host + port + path + version + resource, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        dispatch({ type: LIST_LANGUAGES, payload: response.data });
        callback(response);
      })
      .catch((error) => {
        return error;
      });
  };
}
